import type { OrderStatus } from "../types";
import { readRouteParams } from "../navigation";

export type OrderSortKey = "number" | "customer" | "warehouse" | "orderedAt" | "status";
export interface OrdersLocation {
  status: "" | OrderStatus;
  search: string;
  sort: OrderSortKey;
  descending: boolean;
  page: number;
  partnerPage: number;
  orderId: string | null;
  kind: "regular" | "partner";
}

export function readOrdersLocation(): OrdersLocation {
  const params = readRouteParams();
  const status = params.get("status") as OrderStatus;
  const sort = params.get("sort") as OrderSortKey;
  const id = params.get("order");
  return {
    page: /^\d+$/.test(params.get("page") ?? "") ? Math.max(1,Math.min(100000,Number(params.get("page")))) : 1,
    partnerPage: /^\d+$/.test(params.get("partnerPage") ?? "") ? Math.max(1,Math.min(100000,Number(params.get("partnerPage")))) : 1,
    status: ["New", "Picking", "Picked", "Issued"].includes(status) ? status : "",
    search: params.get("q") ?? "",
    sort: (["number", "customer", "warehouse", "orderedAt", "status"] as OrderSortKey[]).includes(sort) ? sort : "orderedAt",
    descending: params.get("dir") !== "asc",
    orderId: id && /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(id) ? id.toLowerCase() : null,
    kind: params.get("kind") === "partner" ? "partner" : "regular"
  };
}
